import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C5A56]" data-testid="protected-loading">
        Chargement…
      </div>
    );
  }
  if (!user || !user.role) return <Navigate to="/connexion" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/espace-client"} replace />;
  }
  return children;
}
